import { render } from "./Emergency_Services.vue?vue&type=template&id=d92dec04"
import script from "./Emergency_Services.vue?vue&type=script&lang=js"
export * from "./Emergency_Services.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__